import React from 'react'

import Box from '@mui/material/Box'

import { Text } from '@mxenabled/mxui'

interface SaveAnExtra100Props {
  amount: string
  description1: string
  description2: string
  title: string
}

export const SaveAnExtra100: React.FC<SaveAnExtra100Props> = ({
  amount,
  description1,
  description2,
  title,
}) => {
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'success.main',
        borderRadius: 2,
        overflow: 'hidden',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      <Box
        sx={{
          bgcolor: 'success.main',
          color: 'success.contrastText',
          p: 16,
          pt: 12,
          textAlign: 'center',
        }}
      >
        <Text variant="subtitle1">{title}</Text>
        <Text variant="h1">$100.00</Text>
        <Text variant="caption">{description1}</Text>
      </Box>
      <Box
        sx={{
          py: 12,
          px: 16,
          textAlign: 'center',
        }}
      >
        <Text variant="h3">{amount}</Text>
        <Text color="text.secondary" variant="caption">
          {description2}
        </Text>
      </Box>
    </Box>
  )
}
